<template>
  <b-card fluid="lg">
    <b-row>
      <b-col>
        <b-tabs v-model="activeTabIndex" ref="tabs">
          <b-tab title="물류단위 바코드 생성">
            <!-- 첫 번째 탭 내용 -->
            <b-form id="generateBarcodeContainer1">
              <b-form-group label="바코드명">
                <b-form-input type="text" v-model="tab1Data.barcodeName" size="sm"></b-form-input>
                <div v-if="validationErrors.tab1BarcodeName" class="text-danger">{{ validationErrors.tab1BarcodeName }}</div>
              </b-form-group>
              <b-form-group label="시설(바코드가 최초 발행되는 시설)">
                <b-form-select v-model="tab1Data.facilitySelected" :options="facilityOptions" size="sm"></b-form-select>
                <div v-if="validationErrors.tab1FacilitySelected" class="text-danger">{{ validationErrors.tab1FacilitySelected }}</div>
              </b-form-group>
              <b-form-group label="제품">
                <b-form-select v-model="tab1Data.productSelected" :options="productOptions" size="sm"></b-form-select>
                <div v-if="validationErrors.productSelected" class="text-danger">{{ validationErrors.productSelected }}</div>
              </b-form-group>
              <b-form-group label="패키징 타입">    
                <b-form-select v-model="tab1Data.packageSelected" :options="packageOptions" size="sm" @change="onPackageSelect(tab1Data)"></b-form-select>
                <div v-if="validationErrors.packageSelected" class="text-danger">{{ validationErrors.packageSelected }}</div>
              </b-form-group>
              <b-form-group label="규격(가로 x 세로 x 높이)">
                <b-form-input type="text" v-model="tab1Data.dimensions" size="sm"></b-form-input>
                <div v-if="validationErrors.dimensions" class="text-danger">{{ validationErrors.dimensions }}</div>
              </b-form-group>
              <b-form-group label="수량(패키지 내 들어가는 제품 또는 패키지 수량)">
                <b-form-input type="number" v-model="tab1Data.quantity" size="sm"></b-form-input>
                <div v-if="validationErrors.quantity" class="text-danger">{{ validationErrors.quantity }}</div>
              </b-form-group>
              <b-form-group label="단위(패키징 단위)">
                <b-form-input type="text" v-model="tab1Data.uom" size="sm"></b-form-input>
                <div v-if="validationErrors.uom" class="text-danger">{{ validationErrors.uom }}</div>
              </b-form-group>
              <b-form-group label="QR코드 사이즈(px)">
                <b-form-input type="number" v-model="tab1Data.rangeValue" min="32" max="150" size="sm"></b-form-input>
                <div v-if="validationErrors.rangeValue" class="text-danger">{{ validationErrors.rangeValue }}</div>
              </b-form-group>
            </b-form>
          </b-tab>

          <b-tab title="제품단위 바코드 생성">
            <!-- 두 번째 탭 내용 -->
            <b-form id="generateBarcodeContainer2">
              <b-form-group label="바코드명">
                <b-form-input type="text" v-model="tab2Data.barcodeName" size="sm"></b-form-input>
                <div v-if="validationErrors.tab2BarcodeName" class="text-danger">{{ validationErrors.tab2BarcodeName }}</div>
              </b-form-group>
              <b-form-group label="제품">
                <b-form-select v-model="tab2Data.productSelected" :options="productOptions" size="sm"></b-form-select>
                <div v-if="validationErrors.productSelected" class="text-danger">{{ validationErrors.productSelected }}</div>
              </b-form-group>
              <b-form-group label="시설(바코드가 최초 발행되는 시설)">
                <b-form-select v-model="tab2Data.facilitySelected" :options="facilityOptions" size="sm"></b-form-select>
                <div v-if="validationErrors.tab2FacilitySelected" class="text-danger">{{ validationErrors.tab2FacilitySelected }}</div>
              </b-form-group>
              <b-form-group label="발행 단위">
                <b-form-radio-group v-model="tab2Data.qrcodeTypeSelected" :options="qrcodeTypeOptions">
                </b-form-radio-group>
                <div v-if="validationErrors.qrcodeTypeSelected" class="text-danger">{{ validationErrors.qrcodeTypeSelected }}</div>
              </b-form-group>
              <b-form-group label="수량(제품 수량)">
                <b-form-input type="number" v-model="tab2Data.quantity" size="sm"></b-form-input>
                <div v-if="validationErrors.quantity" class="text-danger">{{ validationErrors.quantity }}</div>
              </b-form-group>
              <b-form-group label="단위(제품 단위)">
                <b-form-input type="text" v-model="tab2Data.uom" size="sm"></b-form-input>
                <div v-if="validationErrors.uom" class="text-danger">{{ validationErrors.uom }}</div>
              </b-form-group>
              <b-form-group label="QR코드 사이즈(px)">
                <b-form-input type="number" v-model="tab2Data.rangeValue" min="32" max="150"></b-form-input>
                <div v-if="validationErrors.rangeValue" class="text-danger">{{ validationErrors.rangeValue }}</div>
              </b-form-group>

              <!-- 원재료 정보 입력 섹션 -->
              <b-form-group label="원재료">
                <div v-for="(ingredient, index) in tab2Data.ingredients" :key="index" class="d-flex align-items-center mb-2">
                  <b-form-select v-model="ingredient.productId" :options="allproductOptions" size="sm" class="mr-2 md-unit-input" placeholder="원재료를 선택하세요"></b-form-select>
                  <b-form-input type="number" v-model="ingredient.quantity" size="sm" class="mr-2 sm-unit-input" placeholder="수량"></b-form-input>
                  <b-form-input type="text" v-model="ingredient.uom" size="sm" class="mr-2 sm-unit-input" placeholder="단위"></b-form-input>
                  <b-button size="sm" variant="danger" class="btn-remove" @click="removeIngredient(index)">삭제</b-button>
                </div>
                <b-button size="sm" variant="primary" @click="addIngredient">추가</b-button>
              </b-form-group>
            </b-form>
          </b-tab>
        </b-tabs>
      </b-col>
      <b-col class="text-right">
        <b-link @click="onClose">
          <b-icon icon="x" scale="3"></b-icon>
        </b-link>
        <b-card align="center" img-top style="margin-top:20px;">
          <qrcode-vue :size="currentTabData.rangeValue" :value="qrcodeValue" />
          <b-card-text>
            QR코드 미리보기
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
    <div class="text-center mt-3">
      <b-button style="width: 150px" squared @click="saveData">저장하기</b-button>
    </div>
    <RegisterFormModal ref="registerFormModal" @submit="addItem"></RegisterFormModal>
  </b-card>
</template>


<script>
import RegisterFormModal from './RegisterFormModal.vue';
import AddNewPackageModal from "./AddNewPackageModal.vue";
import QrcodeVue from "qrcode.vue";

export default {
  components: {
    name: "GenerateBarcode",
    RegisterFormModal,
    AddNewPackageModal,
    QrcodeVue,
  },
  props: {
    updateMode: {
      type: Boolean,
      default: false,
    },
  },
  async mounted() {
    try {
      let response = await this.$http.get(`api/barcodes/organization/facility?sortBy=facilityName&order=asc`);
      const facilityOptions = this.facilityOptions;
      if (response.data) {
        const groupedOptions = this.groupFacilitiesByType(response.data);
        // this.facilityOptions = groupedOptions;
        this.facilityOptions = [{ value: '', text: '시설을 선택하세요', disabled: false }, ...groupedOptions];
      }
      response = await this.$http.get(`api/packages`);
      const packageOptions = this.packageOptions;
      if (response.data) {
        response.data.forEach(pkg => {
          packageOptions.push({
            value: pkg,
            text: `${pkg.name}(${pkg.quantity} ${pkg.uom})`
          });
        });
        packageOptions.push({ value: "add new package", text: "새 패키징 타입" });
      }
      
      // 제품 데이터 가져오기 추가
      const org = await this.$getOrganization();
      response = await this.$http.get(`${org._links.products.href}?sort=productName,asc`);
      const products = this.items = response.data._embedded.product;
      const productOptions = this.productOptions;
      if (response.data) {
        products.forEach(product => {
          productOptions.push({
            value: product.id,
            text: product.productName
          });
        });
      }

      console.log('this.$getOrganization()', org)
      response = await this.$http.get(`api/organization/${org.id}/search/findProductByMyOrgAndPartner`);
      
      const all_products = response.data;

      const my_org_products = all_products['myProducts'].map(p => {
        return {
          value: p.id,
          text: p.productName
        }
      });
      const partner_org_products = all_products['partnerProducts'].map(p => {
        return {
          value: p.id,
          text: p.productName
        }
      });

      const organization_group = {
        label: 'My Organization',
        options: my_org_products
      }
      const partner_groups = {
        label: 'My Partner Groups',
        options: partner_org_products
      }
      this.allproductOptions.push(organization_group, partner_groups);
      //여기에서 타 조직의 제품을 가지고 와야함
    } catch (e) {
      console.error(e);
    }
  },
  data() {
    return {
      activeTabIndex: 0,
      facilityOptions: [
        { value: null, text: "시설을 선택해주세요." },
      ],
      packageOptions: [
        { value: null, text: "패키징 타입을 선택해주세요." }
      ],
      qrcodeTypeOptions: [
        { text: "serial", value: "SERIAL" },
        { text: "lot", value: "LOT" },
      ],
      productOptions: [
        { value: null, text: "제품을 선택해주세요." },
      ],
      allproductOptions: [
        { value: null, text: "제품을 선택해주세요." },
      ],
      tab1Data: {
        barcodeName: '',
        facilitySelected: null,
        productSelected: null,
        packageSelected: null,
        qrcodeTypeSelected: "SSCC",
        rangeValue: "50",
        dimensions: '',
        quantity: null,
        uom: ''
      },
      tab2Data: {
        barcodeName: '',
        facilitySelected: null,
        productSelected: null,
        qrcodeTypeSelected: "SERIAL",
        rangeValue: "50",
        quantity: null,
        ingredients: []
      },
      qrcodeValue: "http://localhost:3000",
      isSuccess: false,
      validationErrors: {},
      initialRegisterFormData: {
        name: '',
        typeCode: '',
        dimensions: '',
        quantity: null,
        uom: '',
        image: null,
      }
    };
  },
  methods: {
    groupFacilitiesByType(facilities) {
      const groups = {};

      facilities.forEach(facility => {
        if (!groups[facility.facilityType]) {
          groups[facility.facilityType] = [];
        }
        groups[facility.facilityType].push({
          value: facility.id,
          text: facility.facilityName
        });
      });

      return Object.keys(groups).map(type => ({
        label: type,
        options: groups[type]
      }));
    },
    changeRoute(tabData) {
      const selectVal = tabData.packageSelected;
      if (selectVal === "add new package") {
        this.showModal();
      } else {
        const selectedPackage = this.packageOptions.find(pkg => pkg.value === selectVal);
        if (selectedPackage) {
          tabData.dimensions = selectVal.dimensions;
          tabData.quantity = selectVal.quantity;
          tabData.uom = selectVal.uom;
        }
      }
    },
    onPackageSelect(tabData) {
      const selectVal = tabData.packageSelected;
      if (selectVal === "add new package") {
        this.showModal();
      } else {
        const selectedPackage = this.packageOptions.find(pkg => pkg.value === selectVal);
        if (selectedPackage) {
          tabData.dimensions = selectVal.dimensions;
          tabData.quantity = selectVal.quantity;
          tabData.uom = selectVal.uom;
        }
      }
    },
    async addItem(item) {
      try {

        // console.log(this.currentTabData)
        item.productId = this.currentTabData.productSelected;

        console.log(item)
        const response = await this.$http.post(`api/packages`, item);
        if (response.status === 200) {
          // 새로운 패키지 정보를 options에 추가
          const newPackage = response.data;
          this.packageOptions.push({
            value: newPackage,
            text: `${newPackage.name}(${newPackage.quantity} ${newPackage.uom})`
          });

          // 방금 추가한 패키지를 선택
          this.tab1Data.packageSelected = newPackage;

          this.onPackageSelect(this.tab1Data);
        }
      } catch (error) {
        console.error("패키지를 추가하는 동안 오류가 발생했습니다.", error);
      }
    },
    onClose(event) {

      if(event) {
        event.preventDefault();
      }
      if (this.isSuccess) {
        this.$emit("OnRefresh");
      }
      this.$emit("OnClose");
      this.$nextTick(() => {});
    },
    validateForm(currentTabData) {
      this.validationErrors = {};

      if (currentTabData === this.tab1Data) {
        if (!currentTabData.barcodeName) {
          this.validationErrors.tab1BarcodeName = "바코드명을 입력해주세요.";
        }
        if (!currentTabData.facilitySelected) {
          this.validationErrors.tab1FacilitySelected = "시설을 선택해주세요.";
        }
        if (!currentTabData.packageSelected) {
          this.validationErrors.packageSelected = "패키지 타입을 선택해주세요.";
        }
        if (!currentTabData.qrcodeTypeSelected) {
          this.validationErrors.qrcodeTypeSelected = "발행 단위를 선택해주세요.";
        }
        if (!currentTabData.rangeValue) {
          this.validationErrors.rangeValue = "QR코드 사이즈를 입력해주세요.";
        }
        if (currentTabData.qrcodeTypeSelected === 'lot' && !currentTabData.quantity) {
          this.validationErrors.quantity = "수량을 입력해주세요.";
        }
        if (!currentTabData.dimensions) {
          this.validationErrors.dimensions = "규격을 입력해주세요.";
        }
        if (!currentTabData.quantity) {
          this.validationErrors.quantity = "수량을 입력해주세요.";
        }
        if (!currentTabData.uom) {
          this.validationErrors.uom = "단위를 입력해주세요.";
        }
      }

      if (currentTabData === this.tab2Data) {
        if (!currentTabData.barcodeName) {
          this.validationErrors.tab2BarcodeName = "바코드명을 입력해주세요.";
        }
        if (!currentTabData.facilitySelected) {
          this.validationErrors.tab2FacilitySelected = "시설을 선택해주세요.";
        }
        if (!currentTabData.productSelected) {
          this.validationErrors.productSelected = "제품을 선택해주세요.";
        }
        if (!currentTabData.qrcodeTypeSelected) {
          this.validationErrors.qrcodeTypeSelected = "발행 단위를 선택해주세요.";
        }
        if (!currentTabData.rangeValue) {
          this.validationErrors.rangeValue = "QR코드 사이즈를 입력해주세요.";
        }
        if (!currentTabData.quantity) {
          this.validationErrors.quantity = "수량을 입력해주세요.";
        }
        if (!currentTabData.uom) {
          this.validationErrors.uom = "단위를 입력해주세요.";
        }
      }

      return Object.keys(this.validationErrors).length === 0;
    },
    async saveData() {
      const currentTabData = this.currentTabData;

      if (!this.validateForm(currentTabData)) {
        alert("모든 필드를 올바르게 입력해주세요.");
        return;
      }

      const payload = {
        barcodeName: currentTabData.barcodeName,
        productId: currentTabData.productSelected,
        facilityId: currentTabData.facilitySelected,
        packageId: currentTabData.packageSelected ? currentTabData.packageSelected.id : null,
        qrcodeType: currentTabData.qrcodeTypeSelected,
        qrcodeSize: currentTabData.rangeValue,
        dimensions: currentTabData.dimensions,
        quantity: currentTabData.quantity,
        uom: currentTabData.uom,
        barcodeIngredients: currentTabData.ingredients,
        qrcodeIssuType: this.activeTabIndex === 0 ? 'PACKAGE': 'PRODUCT',
      };

      console.log(currentTabData)
      try {
        const response = await this.$http.post('api/barcodes', payload);
        if (response.status === 200) {
          this.isSuccess = true;
          alert("저장되었습니다.");
          this.onClose();
        } else {
          alert("저장 중 오류가 발생했습니다.");
        }
      } catch (error) {
        console.error(error);
        alert("저장 중 오류가 발생했습니다.");
      }
    },
    showModal() {
      // 팝업 폼 데이터를 초기화
      this.$refs.registerFormModal.resetForm(this.initialRegisterFormData);
      this.$bvModal.show('register-form-modal');
    },
    addIngredient() {
      this.tab2Data.ingredients.push({ material: '', quantity: null, unit: '' });
    },
    removeIngredient(index) {
      this.tab2Data.ingredients.splice(index, 1);
    }
  },
  computed: {
    currentTabData() {
      return this.activeTabIndex === 0 ? this.tab1Data : this.tab2Data;
    }
  },
  watch: {
    'tab1Data.rangeValue': function(newRangeValue) {
      if (this.activeTabIndex === 0) {
        this.qrcodeSize = newRangeValue;
      }
    },
    'tab2Data.rangeValue': function(newRangeValue) {
      if (this.activeTabIndex === 1) {
        this.qrcodeSize = newRangeValue;
      }
    }
  },
};
</script>


<style scoped>
/* 스타일 정의 */
.text-danger {
  color: red;
  font-size: 0.875em;
}
.sm-unit-input {
  width: 70px; /* 단위 입력 박스의 너비를 줄임 */
}
.md-unit-input {
  width: 240px; /* 단위 입력 박스의 너비를 줄임 */
}
</style>
